import { redirect } from '@sveltejs/kit';

export const load = async ({ parent, url }) => {
    const parentLoaders = await parent();

    const persistent = parentLoaders?.user?.persistent;
    const loggedInToShopify = parentLoaders?.user?.isUserLoggedInToShopify;
    // Redirect if not logged in
    if (!loggedInToShopify && url.pathname !== '/account/login') {
        const redirectTo = url.pathname + url.search; // Set return route
        if (persistent) redirect(302, `/api/auth/login?redirectTo=${redirectTo}`);
        else {
            redirect(302, `/account/login?redirectTo=${redirectTo}`);
        }
    }
    return { ...parentLoaders };
};

export const ssr = false;
